import React, { useEffect, useState } from "react";
import { QUESTION_ACTIONS, useFollowUp } from "providers/FollowUpProvider";
import { Tab, Box, Flex, Tabs, Image, VStack, Center, TabList, TabPanel, TabPanels } from "@chakra-ui/react";
import { CheckboxAnswer, CheckboxTask } from "data-models/task-models";
import CheckboxAnswerGroup from "common/CheckboxAnswerGroup/CheckboxAnswerGroup";
import { apiBase } from "services/config";
import { TaskHeading } from "./Common/TaskHeading";
import { TaskAdvice } from "./Common";
import { useTranslation } from "react-i18next";
import {
  bgContainCenterBox,
  centeredBorderTopFlex,
  centeredOuterFlex,
  fadedSpan,
  fullCenter,
  fullCenteredVStack,
  fullColumnCenteredFlex,
  fullColumnFlex,
  fullMaxTabPanel,
  fullRelativeTabs,
  fullTabPanel,
  fullTabPanels,
  fullVStack,
  imageCenterBase,
  scaledImage,
  spacedFullVStack,
  styledTab,
  tabListSpacing,
  taskImageContainer,
  wrappedCenterFlex,
} from "styles/common.styles";

export default function Familjen5Task() {
  const { currentTask, dispatch } = useFollowUp();
  const task = currentTask as CheckboxTask;
  const { t, i18n } = useTranslation();

  const onAnswerChange = (answers: CheckboxAnswer[]) => {
    dispatch({ type: QUESTION_ACTIONS.UPDATE_ANSWERS, payload: answers });
    dispatch({ type: QUESTION_ACTIONS.UNSKIP_CURRENT_TASK });
  };

  const onChangeTab = (index: number) => {
    dispatch({ type: QUESTION_ACTIONS.SET_CURRENT_STEP, payload: index });
  };

  return (
    <Flex {...fullColumnFlex}>
      <VStack {...fullCenteredVStack}>
        <TaskHeading description={task.description} subtitle={task.subtitle} headingTitle={task.title} />
        <Tabs {...fullRelativeTabs} onChange={onChangeTab} index={currentTask.step}>
          <TabList {...tabListSpacing}>
            <Flex {...centeredBorderTopFlex} />
            <Tab {...styledTab}>
              <span style={fadedSpan}>{t("Step")} 1</span>
              {t("Explain_Scenario_Title")}
            </Tab>
            <Tab {...styledTab}>
              <span style={fadedSpan}>{t("Step")} 2</span>
              {t("Explain_Scenario_Title")}
            </Tab>
            <Tab {...styledTab}>
              <span style={fadedSpan}>{t("Step")} 3</span>
              {t("Mark_All_Options_Text")}
            </Tab>
          </TabList>

          <TabPanels {...fullTabPanels}>
            <TabPanel {...fullTabPanel}>
              <VStack {...spacedFullVStack}>
                {task.imageUrl && (
                  <Flex {...centeredOuterFlex}>
                    <Flex {...taskImageContainer}>
                      <Image {...scaledImage} src={apiBase + task.imageUrl} alt="task_image" />
                    </Flex>
                  </Flex>
                )}

                <TaskAdvice
                  instructions={task.taskInstructions}
                  marginTop="0 !important"
                  justifyContent={"center"}
                  width={"auto"}
                  alignSelf={"flex-start"}
                />
              </VStack>
            </TabPanel>
            <TabPanel {...fullTabPanel}>
              <VStack w="full" h="full" justifyContent={"space-between"}>
                {task.images && (
                  <Flex h="80%" justifyContent={"center"} alignItems={"center"}>
                    {task.images && (
                      <Center {...fullCenter}>
                        <Flex {...wrappedCenterFlex} justify={task.imageView ? "space-evenly" : "center"}>
                          {task.images?.map(img => (
                            <Center key={img.url} alignItems={"center"}>
                              <Flex flexDirection="column" alignItems="center" className="optionsWrapper">
                                <Center
                                  {...imageCenterBase}
                                  boxSize={task.imageView ? "" : "calc(min(25vh,25vw))"}
                                  height={task.imageView && "30vh"}
                                  width={task.imageView && "35vw"}
                                  marginBottom={"unset"}
                                  padding={task.imageView ? "8" : ""}
                                >
                                  <Box bgImage={apiBase + img.url} {...bgContainCenterBox} />
                                </Center>
                              </Flex>
                            </Center>
                          ))}
                        </Flex>
                      </Center>
                    )}
                  </Flex>
                )}
                <TaskAdvice
                  instructions={task?.taskInstructions_2 ?? ""}
                  marginTop="0 !important"
                  justifyContent={"center"}
                  width={"auto"}
                  alignSelf={"flex-start"}
                />
              </VStack>
            </TabPanel>
            <TabPanel {...fullMaxTabPanel}>
              <VStack {...fullVStack}>
                <Flex {...fullColumnCenteredFlex}>
                  <CheckboxAnswerGroup options={task.answerOptions} onChange={onAnswerChange} />
                </Flex>
                <TaskAdvice instructions={task.answerInstructions} marginTop="auto !important" />
              </VStack>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </VStack>
    </Flex>
  );
}
